import * as FF_KEYS from './featureFlags';

export type FFDefaults = {
  [FF_KEYS.FF_ENABLE_SNOWPLOW]: boolean;
  [FF_KEYS.FF_TEST_FLAG]: boolean;
  [FF_KEYS.FF_ENABLE_BULK_DISCOUNTS]: boolean;
  [FF_KEYS.FF_ENABLE_DISCOUNTS_SYNC]: boolean;
  [FF_KEYS.FF_LOYALTY]: boolean;
  [FF_KEYS.FF_ABOUT_LEAFIO_LOYALTY]: boolean;
  [FF_KEYS.FF_CLOUDFLARE_TURNSTILE]: boolean;
  [FF_KEYS.FF_TOP_PICKS]: boolean;
  [FF_KEYS.FF_MOQ_RULES]: boolean;
  [FF_KEYS.FF_SHIPMENTS_V2]: boolean;
  [FF_KEYS.FF_DELIVERY_ESTIMATES]: boolean;
  [FF_KEYS.FF_CART_DELIVERY_ESTIMATES]: boolean;
  [FF_KEYS.FF_STORE_CART_DELIVERY_ESTIMATE]: boolean;
  [FF_KEYS.FF_DISPLAY_MOQ_PDP]: boolean;
  [FF_KEYS.FF_SHIPMENTS_BULK_PAYMENT]: boolean;
  [FF_KEYS.FF_BUNDLE_FEATURE]: boolean;
  [FF_KEYS.FF_FREQUENTLY_PURCHASED]: boolean;
  [FF_KEYS.FF_ENABLE_SIDE_BAR_BANNER_IN_LOYALTY_PAGE]: boolean;
  [FF_KEYS.FF_ENABLE_TOP_BANNER_IN_ACCOUNT_PAGE]: boolean;
  [FF_KEYS.FF_ENABLE_BANNER_IN_CART_PAGE]: boolean;
  [FF_KEYS.FF_APPROVAL_PATIENT_DETAILS]: boolean;
  [FF_KEYS.FF_ENABLE_CAROUSEL_BANNER_IN_PRODUCTS_PAGE]: boolean;
};

export const ffDefaults: FFDefaults = {
  [FF_KEYS.FF_ENABLE_SNOWPLOW]: false,
  [FF_KEYS.FF_TEST_FLAG]: false,
  [FF_KEYS.FF_ENABLE_BULK_DISCOUNTS]: true,
  [FF_KEYS.FF_ENABLE_DISCOUNTS_SYNC]: false,
  [FF_KEYS.FF_LOYALTY]: false,
  [FF_KEYS.FF_ABOUT_LEAFIO_LOYALTY]: false,
  [FF_KEYS.FF_CLOUDFLARE_TURNSTILE]: true,
  [FF_KEYS.FF_TOP_PICKS]: false,
  [FF_KEYS.FF_MOQ_RULES]: false,
  [FF_KEYS.FF_SHIPMENTS_V2]: false,
  [FF_KEYS.FF_DELIVERY_ESTIMATES]: true,
  [FF_KEYS.FF_CART_DELIVERY_ESTIMATES]: false,
  [FF_KEYS.FF_STORE_CART_DELIVERY_ESTIMATE]: false,
  [FF_KEYS.FF_DISPLAY_MOQ_PDP]: false,
  [FF_KEYS.FF_SHIPMENTS_BULK_PAYMENT]: false,
  [FF_KEYS.FF_BUNDLE_FEATURE]: false,
  [FF_KEYS.FF_FREQUENTLY_PURCHASED]: false,
  [FF_KEYS.FF_ENABLE_SIDE_BAR_BANNER_IN_LOYALTY_PAGE]: false,
  [FF_KEYS.FF_ENABLE_TOP_BANNER_IN_ACCOUNT_PAGE]: false,
  [FF_KEYS.FF_ENABLE_BANNER_IN_CART_PAGE]: false,
  [FF_KEYS.FF_APPROVAL_PATIENT_DETAILS]: false,
  [FF_KEYS.FF_ENABLE_CAROUSEL_BANNER_IN_PRODUCTS_PAGE]: false,
};
